import { call, put, takeEvery } from 'redux-saga/effects'
import { userScanCenterLogin, userScanCenterLoginSuccess, userScanCenterLoginFailed } from './slice'
import { API } from 'src/scanCenter/services/index'

function* loginScanCenterApi({ payload }) {
  try {
    const response = yield call(API.authApi.loginApiScanCenter, payload)
    if (
      response?.status === 200 &&
      response?.data &&
      response?.data?.code === 0 &&
      response?.data?.error === false
    ) {
      yield put(userScanCenterLoginSuccess({ payload: response?.data }))
    } else {
      yield put(userScanCenterLoginFailed({ message: response?.data?.message }))
    }
  } catch (error) {
    yield put(userScanCenterLoginFailed({ message: error?.message }))
  }
}

function* authSaga() {
  yield takeEvery(userScanCenterLogin, loginScanCenterApi)
}

export default authSaga
